<dx-resizable [width]="size.Width"
              [height]="size.Height"
              [minWidth]="100"
              [minHeight]="100"
              (onResize)="onResize($event)"
              class="ep-chart">
    <dx-pie-chart id="pie"
                  [title]="$safeNavigationMigration(chartConfiguration?.Header)"
                  [palette]="currentPalette"
                  [dataSource]="valueFields">
        <dxi-series argumentField="Name"
                    valueField="Value">
            <dxo-label [visible]="true">
                <dxo-connector [visible]="true"
                               [width]="1"></dxo-connector>
            </dxo-label>
        </dxi-series>
        <dxo-legend verticalAlignment="bottom"
                    horizontalAlignment="center">
        </dxo-legend>
        <dxo-size [width]="innerSize.Width" [height]="innerSize.Height"></dxo-size>
        <dxo-tooltip [enabled]="true"></dxo-tooltip>
        <dxo-export [enabled]="true"></dxo-export>
    </dx-pie-chart>
</dx-resizable>